export const NumericComparator = (a, b) => {
    // Parse the values of a and b to numbers
    const numA = parseFloat(a);
    const numB = parseFloat(b);

    // Check if one of the values is NaN (not a number)
    if (isNaN(numA) && isNaN(numB)) {
        // If both a and b are not numbers, return 0 (assuming both non-numeric values are equal)
        return 0;
    } else if (isNaN(numA)) {
        // If a is not a number, return -1 (assuming non-numeric values should be considered less than numeric values)
        return -1;
    } else if (isNaN(numB)) {
        // If b is not a number, return 1 (assuming non-numeric values should be considered greater than numeric values)
        return 1;
    }
    
    // Compare the parsed numeric values
    return numA - numB;
};
